module.exports = __webpack_public_path__ + "static/media/delete-icon.b34f51c7.svg";